module.exports = __webpack_public_path__ + "static/media/blog-episodes-list.4420efc9.png";